export const selectLists = state => state.shipping.lists;

export const selectBoxId = state => state.shipping.currentBoxId;